export default "__VITE_ASSET__CX99eZE4__"